import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/driving-info/SelectMonthBottomSheet/.eu';
import Kr from '@di-shared/features/history/driving-info/SelectMonthBottomSheet/.kr';
import Na from '@di-shared/features/history/driving-info/SelectMonthBottomSheet/.na';

export interface SelectMonthBottomSheetData {
  months: Array<Date>;
  selectedDate: Date | undefined;
}

export default function SelectMonthBottomSheet() {
  return (
    <>
      <Environment.Eu>
        <Eu />
      </Environment.Eu>
      <Environment.Kr>
        <Kr />
      </Environment.Kr>
      <Environment.Na>
        <Na />
      </Environment.Na>
    </>
  );
}
